import React, { Component } from 'react';
import { Route } from 'react-router';
import PrivateRoute from './PrivateRoute'
import AuthService from './services/AuthService.js' 

import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import { LoginForm } from './components/Login/LoginForm';
import { LogoutForm } from './components/Logout/LogoutForm';
import { AutodiagnosticoForm } from './components/Autodiagnostico/AutodiagnosticoForm';
import { AutodiagnosticoConfirmacionForm } from './components/Autodiagnostico/AutodiagnosticoConfirmacionForm';
import { IdentificacionForm } from './components/Identificacion/IdentificacionForm';
import { CalendarioForm } from './components/Calendario/CalendarioForm';
import { CambiarClaveForm } from './components/CambiarClave/CambiarClaveForm';
import { RecuperarClaveForm } from './components/RecuperarClave/RecuperarClaveForm';


import './custom.css'

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = { authed: AuthService.isLoggedIn()};

        this.handleLogout = this.handleLogout.bind(this);
        this.handleLogin = this.handleLogin.bind(this); 
    } 

    handleLogout(event) {
        event.preventDefault();
        localStorage.removeItem('token');
        this.setState({ authed: false });
    }

    handleLogin(token) {
        localStorage.setItem('token', token);
        this.setState({ authed: true });
    }

    render() {
        return (
            <Layout>
                <Route exact path='/' component={() => <LoginForm handleLogin={this.handleLogin} />} />
                <Route exact path='/login' component={() => <LoginForm handleLogin={this.handleLogin} />} />
                <Route path='/logout' component={LogoutForm} />
                <PrivateRoute path='/home' component={Home} />
                <PrivateRoute path='/autodiagnostico' component={AutodiagnosticoForm} />
                <PrivateRoute path='/autodiagnosticoconfirmacion' component={AutodiagnosticoConfirmacionForm} />
                <PrivateRoute path='/identificacion' component={IdentificacionForm} />
                <PrivateRoute path='/calendario' component={CalendarioForm} />
                <PrivateRoute path='/cambiarclave' component={CambiarClaveForm} />
                <Route path='/recuperarclave' component={RecuperarClaveForm} />
            </Layout>
        );
    }
}
